import { useThemeStore } from "@stores/theme.store";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";
import { PopupConfirm, PopupCustom } from "@components/general/popup";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";

import MaleLogo from "@assets/images/avatar.png";
import FemaleLogo from "@assets/images/avatar-female.png";
import { androidSetupBiometric } from "@utils/android";
import { useBiometricStore } from "@stores/biometric.store";
import { FaAngleRight, FaBarcode, FaFingerprint } from "react-icons/fa";
import { PiCaretRightLight } from "react-icons/pi";
import { FcBusinessContact, FcExport, FcLock } from "react-icons/fc";
import { Button } from "antd";
import JsBarcode from "jsbarcode";

export const ProfilePage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar, popupStatus, setPopupStatus } = useThemeStore(
    (state) => state
  );
  const [isBiometric, setIsBiometric] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { isActiveBiometric } = useBiometricStore((state) => state);
  // const [popupLogout, setPopupLogout] = useState<boolean>(false);

  const { data: dataNis, isSuccess: isSuccessNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "---";
  const gender = dataNis?.data?.gender ?? "";

  const { data, isPending } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
  });

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Profil",
      image: false,
      // buttonLogout: true,
    });
    setAppBar({ title: "Profil", show: true, leading: "back" });
  }, [setHeader, setAppBar]);

  useEffect(() => {
    const skip = localStorage.getItem("is-biometric");
    setIsBiometric(skip === "true");
  }, []);

  const onSetupBiometric = () => {
    const status = localStorage.getItem("status-biometric");
    if (status === "register") {
      androidSetupBiometric("remove");
    } else {
      androidSetupBiometric("register");
    }
  };

  const onLogout = () => {
    Cookies.remove("token");
    Cookies.remove("redirect");
    // localStorage.setItem("nis", "");
    navigate("/auth/login");
    setPopupStatus(false);
    setAppBar({ show: false });
  };

  const barcodeRef = useCallback(
    (node: SVGSVGElement) => {
      if (node && isSuccessNis && nis && nis !== "---") {
        // Clear any existing content
        node.innerHTML = "";

        try {
          JsBarcode(node as unknown as HTMLElement, nis, {
            format: "CODE128",
            width: 2.5,
            height: 100,
            displayValue: true,
          });
        } catch (error) {
          console.error("Barcode generation failed:", error);
        }
      }
    },
    [isSuccessNis, nis]
  );

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className="tw-mb-4 tw-mt-12 tw-pt-14 tw-relative tw-text-center card-body">
          <div className="tw-p-2 tw-rounded-full tw-text-center tw-mb-4 tw-absolute tw-top-0 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2">
            <img
              src={
                isPending
                  ? MaleLogo
                  : data?.data?.foto === null || data?.data?.foto === ""
                  ? gender === "Pria" || gender === "PRIA" || gender === ""
                    ? MaleLogo
                    : FemaleLogo
                  : `https://sip2.darululumkalbar.com//assets/fotosiswa/${data?.data?.foto}`
              }
              alt=""
              className="tw-w-24 tw-h-24 tw-object-cover tw-rounded-full tw-aling-middle tw-border-[5px] tw-border-solid tw-border-primary tw-bg-gray-100"
            />
          </div>

          <div className="tw-text-lg tw-font-medium tw-text-text-primary">
            {data?.data?.namasiswa ?? "---"}
          </div>

          <div className="tw-text-xs tw-text-text-secondary">
            Kelas {data?.data?.kelas}
          </div>

          <div className="tw-text-xs tw-text-text-secondary">
            Marhalah {data?.data?.marhalah}
          </div>

          <div className="tw-my-4 divider"></div>
          {/* </div>

        <div className="tw-mt-4 card-body"> */}
          <div className="tw-text-left">
            <div className="tw-mb-3 tw-text-lg tw-font-medium tw-text-text-primary md:tw-text-2xl">
              Umum
            </div>

            <div
              className="tw-mb-4 tw-w-full tw-flex tw-items-center"
              onClick={() => navigate(linkPage.SETTING_UPDATE_ACCOUNT)}
            >
              <FcBusinessContact className="tw-h-[20px] tw-w-[20px] tw-p-1 tw-bg-[#f2f0fc] tw-text-accent-primary tw-rounded-lg" />
              <div className="tw-ml-2 tw-w-[90%]">
                <div className="tw-d-block tw-text-sm tw-font-bold tw-text-accent-primary">
                  Edit Profil
                </div>
                <div className="tw-text-[10px] tw-text-text-secondary">
                  Ubah data informasi siswa
                </div>
              </div>
              <div>
                <PiCaretRightLight />
              </div>
            </div>

            <div
              className="tw-mb-4 tw-w-full tw-flex tw-items-center"
              onClick={() =>
                navigate(linkPage.SETTING_CHANGE_PASSWORD, {
                  state: dataNis?.data,
                })
              }
            >
              <FcLock className="tw-h-[20px] tw-w-[20px] tw-p-1 tw-bg-[#f2f0fc] tw-text-accent-primary tw-rounded-lg" />
              <div className="tw-ml-2 tw-w-[90%]">
                <div className="tw-d-block tw-text-sm tw-font-bold tw-text-accent-primary">
                  Ubah Kata Sandi
                </div>
                <div className="tw-text-[10px] tw-text-text-secondary">
                  Perbarui kata sandi akun
                </div>
              </div>
              <div>
                <PiCaretRightLight />
              </div>
            </div>

            <div
              className="tw-w-full tw-flex tw-items-center"
              onClick={() => setModalOpen(true)}
            >
              <FaBarcode className="tw-h-[20px] tw-w-[20px] tw-p-1 tw-bg-[#f2f0fc] tw-text-accent-primary tw-rounded-lg" />
              <div className="tw-ml-2 tw-w-[90%]">
                <div className="tw-d-block tw-text-sm tw-font-bold tw-text-accent-primary">
                  Barcode
                </div>
                <div className="tw-text-[10px] tw-text-text-secondary">
                  Menampilkan barcode NIS
                </div>
              </div>
              <div>
                <PiCaretRightLight />
              </div>
            </div>
          </div>
        </div>

        <div className="tw-mt-4 card-body">
          <div className="tw-mb-3 tw-text-lg tw-font-medium tw-text-text-primary md:tw-text-2xl">
            Preferensi
          </div>

          <div
            className="tw-w-full tw-flex tw-items-center"
            onClick={() => setPopupStatus(true)}
          >
            <FcExport className="tw-h-[20px] tw-w-[20px] tw-p-1 tw-bg-red-50 tw-text-red-500 tw-rounded-lg" />
            <div className="tw-ml-2 tw-w-[90%]">
              <div className="tw-d-block tw-text-sm tw-font-bold tw-text-red-500">
                Keluar
              </div>
              <div className="tw-text-[10px] tw-text-text-secondary">
                keluar dari akun dengan aman
              </div>
            </div>
            <div>
              <PiCaretRightLight />
            </div>
          </div>

          {isBiometric ? (
            <div
              className="tw-list-group-item tw-d-flex tw-px-0 tw-py-3 tw-border-[rgba(0,0,0,0.05)] tw-cursor-pointer"
              onClick={onSetupBiometric}
            >
              <div
                className={`tw-rounded-sm tw-w-8 tw-h-8 tw-d-flex tw-flex-none tw-my-auto ${
                  isActiveBiometric ? "tw-bg-teal-dark" : "tw-bg-gray-dark"
                }`}
              >
                <FaFingerprint className="tw-m-auto" />
              </div>
              <div className="tw-grow tw-mx-3 tw-my-auto tw-d-flex tw-flex-column tw-w-[calc(100vw-140px)]">
                <span className="tw-font-medium tw-text-sm tw-truncate">
                  {isActiveBiometric
                    ? "Login Biometrik Aktif"
                    : "Aktifkan Login Biometrik"}
                </span>
                <strong className="tw-font-medium tw-text-[11px] tw-text-[#adb5bd] tw-truncate">
                  {isActiveBiometric
                    ? "Login cepat biometrik sudah aktif"
                    : "Fitur login cepat dengan biometrik"}
                </strong>
              </div>
              <div className="tw-my-auto">
                <FaAngleRight className="" size={10} />
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <PopupConfirm
        open={popupStatus}
        title={dataNis?.data?.nama ?? "-"}
        message="Yakin ingin keluar dari Sipond?"
        textConfirm="Keluar"
        textCancel="Batalkan"
        onConfirm={onLogout}
        onCancel={() => setPopupStatus(false)}
      />

      <PopupCustom
        slideUpModal={false}
        open={modalOpen}
        title="Barcode NIS"
        onClose={() => setModalOpen(false)}
      >
        <div className="">
          <div className="tw-flex tw-justify-center">
            <svg key={nis} ref={barcodeRef}></svg>
          </div>
          <Button
            onClick={() => setModalOpen(false)}
            className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-base tw-rounded-xl tw-bg-red-500 tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
          >
            Tutup
          </Button>
        </div>
      </PopupCustom>
    </>
  );
};
